(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
  /*
   * Spaziature di Shopify Forms che non hanno una variabile CSS:
   * aggiunge un piccolo foglio di stile dentro lo shadow DOM del form.
   * Lo script modifica solo margini e spaziature, non nasconde mai nulla:
   * se Shopify cambia la struttura del form, le regole non trovano gli
   * elementi e il form resta visibile con le spaziature originali.
   */
  (function () {
    var CSS =
      'h2 { margin-bottom: var(--sigma-forms-heading-gap, 16px) !important; }' +
      'form { row-gap: var(--sigma-forms-field-gap, 16px) !important; }' +
      '[class*="consentCheckboxContainer"] { margin-top: 0 !important; }' +
      // Testo sotto il pulsante di invio (es. informativa privacy).
      'button[type="submit"] ~ *, button[type="submit"] ~ * * { font-size: var(--sigma-forms-note-size, 13px) !important; }' +
      '@supports selector(:has(*)) {' +
        ':has(> button[type="submit"]) ~ *, :has(> button[type="submit"]) ~ * * { font-size: var(--sigma-forms-note-size, 13px) !important; }' +
      '}' +
      // Consenso email prima del pulsante: cambia solo l'ordine visivo (il form è flex/grid),
      // senza spostare i nodi, che sono gestiti dall'app e verrebbero ricreati.
      '@supports selector(:has(*)) {' +
        'form > button[type="submit"], form > button[type="submit"] ~ *,' +
        'form > :has(button[type="submit"]), form > :has(button[type="submit"]) ~ * { order: 2; }' +
        'form > [class*="consentCheckboxContainer"], form > :has([name="emailConsent"], [id*="emailConsent"]) { order: 1 !important; }' +
      '}' +
      // Menu a tendina (es. Provincia): l'etichetta diventa il placeholder dentro il campo.
      // Senza supporto a :has() l'etichetta resta sopra il campo come in origine.
      '@supports selector(:has(*)) {' +
        '[class*="selectContainer"]:has(> button [class*="selectToggleText"]:empty) { display: grid !important; }' +
        '[class*="selectContainer"]:has(> button [class*="selectToggleText"]:empty) > button { grid-area: 1 / 1; }' +
        '[class*="selectContainer"]:has(> button [class*="selectToggleText"]:empty) > p[class*="label"] {' +
          'grid-area: 1 / 1; align-self: center; z-index: 1; pointer-events: none;' +
          'margin: 0 !important; padding: 0 40px 0 15px !important;' +
          'color: var(--form-placeholder-color) !important;' +
        '}' +
        // Con un valore scelto l'etichetta sparisce alla vista ma resta per gli screen reader.
        '[class*="selectContainer"]:has(> button [class*="selectToggleText"]:not(:empty)) > p[class*="label"] {' +
          'position: absolute !important; width: 1px !important; height: 1px !important;' +
          'padding: 0 !important; margin: -1px !important; overflow: hidden !important;' +
          'clip: rect(0 0 0 0) !important; white-space: nowrap !important; border: 0 !important;' +
        '}' +
      '}';

    function inject(host) {
      try {
        var root = host.shadowRoot;
        if (!root || root.__sigmaStyled) return;
        if ('adoptedStyleSheets' in root && typeof CSSStyleSheet === 'function' && 'replaceSync' in CSSStyleSheet.prototype) {
          var sheet = new CSSStyleSheet();
          sheet.replaceSync(CSS);
          root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
        } else {
          var style = document.createElement('style');
          style.textContent = CSS;
          root.appendChild(style);
        }
        root.__sigmaStyled = true;
      } catch (e) {}
    }

    function scan() {
      try {
        document.querySelectorAll('.apps-section shopify-forms-embed').forEach(inject);
      } catch (e) {}
    }

    // Il form viene caricato in ritardo dall'app: lo intercettiamo appena compare.
    function start() {
      scan();
      try {
        new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
      } catch (e) {}
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-community"]) return;
  try {
    

/*
  Self-contained gallery: no third-party library and no thumbnail strip.
  A custom element initializes both on page load and after Theme Editor renders.
  All listeners belong to one instance and are removed when it disconnects.
*/
if (!customElements.get('article-community-gallery')) {
  class ArticleCommunityGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initFrame = window.requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || this.initialized) return;

      this.viewport = this.querySelector('[data-gallery-viewport]');
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.thumbnails = Array.from(this.querySelectorAll('[data-gallery-thumbnail]'));
      this.controls = Array.from(this.querySelectorAll('[data-gallery-control]'));
      this.status = this.querySelector('[data-gallery-status]');

      if (!this.viewport || !this.track || !this.slides.length) return;

      this.initialized = true;
      this.controller = new AbortController();
      this.currentIndex = 0;
      this.pointerStart = null;
      const options = { signal: this.controller.signal };

      this.viewport.scrollLeft = 0;
      this.setAttribute('data-enhanced', 'true');
      this.controls.forEach((control) => { control.hidden = false; });

      const previousButton = this.querySelector('[data-gallery-prev]');
      const nextButton = this.querySelector('[data-gallery-next]');

      if (previousButton) {
        previousButton.addEventListener('click', () => {
          this.showImage(this.currentIndex - 1);
        }, options);
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          this.showImage(this.currentIndex + 1);
        }, options);
      }

      this.thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => this.showImage(index), options);
      });

      this.addEventListener('keydown', (event) => {
        if (this.slides.length < 2 || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;

        let index;
        switch (event.key) {
          case 'ArrowLeft': index = this.currentIndex - 1; break;
          case 'ArrowRight': index = this.currentIndex + 1; break;
          case 'Home': index = 0; break;
          case 'End': index = this.slides.length - 1; break;
          default: return;
        }
        event.preventDefault();
        this.showImage(index);
      }, options);

      this.viewport.addEventListener('dragstart', (event) => event.preventDefault(), options);

      this.viewport.addEventListener('pointerdown', (event) => {
        if (this.slides.length < 2 || !event.isPrimary || event.button !== 0) return;
        this.pointerStart = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY
        };
        try { this.viewport.setPointerCapture(event.pointerId); } catch (_) { /* Pointer already released. */ }
      }, options);

      this.viewport.addEventListener('pointerup', (event) => {
        if (!this.pointerStart || this.pointerStart.id !== event.pointerId) return;
        const deltaX = event.clientX - this.pointerStart.x;
        const deltaY = event.clientY - this.pointerStart.y;
        this.pointerStart = null;
        const threshold = Math.max(35, Math.min(90, this.viewport.clientWidth * 0.1));

        if (Math.abs(deltaX) >= threshold && Math.abs(deltaX) > Math.abs(deltaY) * 1.3) {
          this.showImage(this.currentIndex + (deltaX < 0 ? 1 : -1));
        }
      }, options);

      const cancelPointer = () => { this.pointerStart = null; };
      this.viewport.addEventListener('pointercancel', cancelPointer, options);
      this.viewport.addEventListener('lostpointercapture', cancelPointer, options);

      this.showImage(0, false);
    }

    showImage(index, announce = true) {
      const count = this.slides.length;
      if (!count || !Number.isFinite(index)) return;

      this.currentIndex = ((index % count) + count) % count;
      this.track.style.transform = `translate3d(-${this.currentIndex * 100}%, 0, 0)`;

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.currentIndex;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.inert = !active;
      });

      this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const active = thumbnailIndex === this.currentIndex;
        thumbnail.classList.toggle('is-active', active);
        if (active) thumbnail.setAttribute('aria-current', 'true');
        else thumbnail.removeAttribute('aria-current');
      });

      const image = this.slides[this.currentIndex].querySelector('img');

      if (announce) {
        if (image) image.loading = 'eager';
        if (this.status) {
          const label = this.dataset.imageLabel || 'Image';
          const of = this.dataset.ofLabel || 'of';
          this.status.textContent = `${label} ${this.currentIndex + 1} ${of} ${count}`;
        }
      }
    }

    disconnectedCallback() {
      window.cancelAnimationFrame(this.initFrame);
      if (this.controller) this.controller.abort();
      this.initialized = false;
      this.pointerStart = null;
      this.removeAttribute('data-enhanced');
      if (this.track) this.track.style.removeProperty('transform');
      if (this.controls) this.controls.forEach((control) => { control.hidden = true; });
      if (this.slides) {
        this.slides.forEach((slide) => {
          slide.removeAttribute('aria-hidden');
          slide.inert = false;
        });
      }
    }
  }

  customElements.define('article-community-gallery', ArticleCommunityGallery);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-interview"]) return;
  try {
    

/*
  Self-contained gallery: no third-party library and no thumbnail strip.
  A custom element initializes both on page load and after Theme Editor renders.
  All listeners belong to one instance and are removed when it disconnects.
*/
if (!customElements.get('article-interview-gallery')) {
  class ArticleInterviewGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initFrame = window.requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || this.initialized) return;

      this.viewport = this.querySelector('[data-gallery-viewport]');
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.thumbnails = Array.from(this.querySelectorAll('[data-gallery-thumbnail]'));
      this.controls = Array.from(this.querySelectorAll('[data-gallery-control]'));
      this.status = this.querySelector('[data-gallery-status]');

      if (!this.viewport || !this.track || !this.slides.length) return;

      this.initialized = true;
      this.controller = new AbortController();
      this.currentIndex = 0;
      this.pointerStart = null;
      const options = { signal: this.controller.signal };

      this.viewport.scrollLeft = 0;
      this.setAttribute('data-enhanced', 'true');
      this.controls.forEach((control) => { control.hidden = false; });

      const previousButton = this.querySelector('[data-gallery-prev]');
      const nextButton = this.querySelector('[data-gallery-next]');

      if (previousButton) {
        previousButton.addEventListener('click', () => {
          this.showImage(this.currentIndex - 1);
        }, options);
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          this.showImage(this.currentIndex + 1);
        }, options);
      }

      this.thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => this.showImage(index), options);
      });

      this.addEventListener('keydown', (event) => {
        if (this.slides.length < 2 || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;

        let index;
        switch (event.key) {
          case 'ArrowLeft': index = this.currentIndex - 1; break;
          case 'ArrowRight': index = this.currentIndex + 1; break;
          case 'Home': index = 0; break;
          case 'End': index = this.slides.length - 1; break;
          default: return;
        }
        event.preventDefault();
        this.showImage(index);
      }, options);

      this.viewport.addEventListener('dragstart', (event) => event.preventDefault(), options);

      this.viewport.addEventListener('pointerdown', (event) => {
        if (this.slides.length < 2 || !event.isPrimary || event.button !== 0) return;
        this.pointerStart = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY
        };
        try { this.viewport.setPointerCapture(event.pointerId); } catch (_) { /* Pointer already released. */ }
      }, options);

      this.viewport.addEventListener('pointerup', (event) => {
        if (!this.pointerStart || this.pointerStart.id !== event.pointerId) return;
        const deltaX = event.clientX - this.pointerStart.x;
        const deltaY = event.clientY - this.pointerStart.y;
        this.pointerStart = null;
        const threshold = Math.max(35, Math.min(90, this.viewport.clientWidth * 0.1));

        if (Math.abs(deltaX) >= threshold && Math.abs(deltaX) > Math.abs(deltaY) * 1.3) {
          this.showImage(this.currentIndex + (deltaX < 0 ? 1 : -1));
        }
      }, options);

      const cancelPointer = () => { this.pointerStart = null; };
      this.viewport.addEventListener('pointercancel', cancelPointer, options);
      this.viewport.addEventListener('lostpointercapture', cancelPointer, options);

      this.showImage(0, false);
    }

    showImage(index, announce = true) {
      const count = this.slides.length;
      if (!count || !Number.isFinite(index)) return;

      this.currentIndex = ((index % count) + count) % count;
      this.track.style.transform = `translate3d(-${this.currentIndex * 100}%, 0, 0)`;

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.currentIndex;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.inert = !active;
      });

      this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const active = thumbnailIndex === this.currentIndex;
        thumbnail.classList.toggle('is-active', active);
        if (active) thumbnail.setAttribute('aria-current', 'true');
        else thumbnail.removeAttribute('aria-current');
      });

      const image = this.slides[this.currentIndex].querySelector('img');

      if (announce) {
        if (image) image.loading = 'eager';
        if (this.status) {
          const label = this.dataset.imageLabel || 'Image';
          const of = this.dataset.ofLabel || 'of';
          this.status.textContent = `${label} ${this.currentIndex + 1} ${of} ${count}`;
        }
      }
    }

    disconnectedCallback() {
      window.cancelAnimationFrame(this.initFrame);
      if (this.controller) this.controller.abort();
      this.initialized = false;
      this.pointerStart = null;
      this.removeAttribute('data-enhanced');
      if (this.track) this.track.style.removeProperty('transform');
      if (this.controls) this.controls.forEach((control) => { control.hidden = true; });
      if (this.slides) {
        this.slides.forEach((slide) => {
          slide.removeAttribute('aria-hidden');
          slide.inert = false;
        });
      }
    }
  }

  customElements.define('article-interview-gallery', ArticleInterviewGallery);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-sws"]) return;
  try {
    
/*
  No automatic consent writes. Unknown/failed consent reads keep the player blocked.
  Native path: Shopify Customer Privacy API + window.privacyBanner.
  Custom CMP bridge (optional): window.sigmaSwsVideoConsent = {
    isAllowed: () => boolean,
    openPreferences: () => void | Promise<void>
  };
  Dispatch document event "sigma:sws:consent-changed" after CMP status changes.
  The bridge takes precedence, including false and unknown results.
*/
(() => {
  if (customElements.get('article-sws-youtube')) return;
  let privacyLoadPromise;

  // iubenda is the site CMP: video requires purpose 3 (experience). No iubenda = blocked.
  if (!window.sigmaSwsVideoConsent) {
    window.sigmaSwsVideoConsent = {
      isAllowed: () => window._iub?.cs?.api?.getPreferences?.()?.purposes?.[3] === true,
      openPreferences: () => window._iub.cs.api.openPreferences()
    };
    let iubTries = 0;
    const iubTimer = window.setInterval(() => {
      if (!window._iub?.cs?.api && ++iubTries < 40) return;
      window.clearInterval(iubTimer);
      document.dispatchEvent(new Event('sigma:sws:consent-changed'));
    }, 250);
  }

  function loadPrivacyApi() {
    if (window.Shopify?.customerPrivacy) return Promise.resolve();
    if (privacyLoadPromise) return privacyLoadPromise;
    if (typeof window.Shopify?.loadFeatures !== 'function') return Promise.resolve();
    privacyLoadPromise = new Promise((resolve) => {
      let complete = false;
      const finish = () => {
        if (complete) return;
        complete = true;
        window.clearTimeout(timer);
        resolve();
      };
      const timer = window.setTimeout(finish, 5000);
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
          finish();
          document.dispatchEvent(new Event('sigma:sws:privacy-ready'));
        });
      } catch (_) {
        finish();
      }
    });
    return privacyLoadPromise;
  }

  function hasVideoPermission() {
    try {
      const bridge = window.sigmaSwsVideoConsent;
      if (bridge) {
        return typeof bridge.isAllowed === 'function' && bridge.isAllowed() === true;
      }
      return window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
    } catch (_) {
      return false;
    }
  }

  class ArticleSwsYouTube extends HTMLElement {
    connectedCallback() {
      if (this.listenerController) return;
      // Defer to ensure children are parsed on dynamic Theme Editor insertions.
      this.initFrame = window.requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || this.listenerController) return;
      this.placeholder = this.querySelector('[data-video-placeholder]');
      this.preferences = this.querySelector('[data-video-preferences]');
      this.message = this.querySelector('[data-consent-message]');
      if (!this.placeholder || !this.preferences) return;
      if (!/^[A-Za-z0-9_-]{11}$/.test(this.dataset.videoId || '')) return;

      this.listenerController = new AbortController();
      const { signal } = this.listenerController;
      const refresh = () => this.updatePlayer();
      this.preferences.hidden = false;
      this.preferences.addEventListener('click', () => this.openPreferences(), { signal });
      document.addEventListener('visitorConsentCollected', refresh, { signal });
      document.addEventListener('sigma:sws:consent-changed', refresh, { signal });
      document.addEventListener('sigma:sws:privacy-ready', refresh, { signal });
      window.addEventListener('focus', refresh, { signal });
      window.addEventListener('load', () => loadPrivacyApi().then(refresh), { once: true, signal });
      this.updatePlayer();
      loadPrivacyApi().then(refresh);
    }

    updatePlayer() {
      if (!this.isConnected || !this.listenerController || !this.placeholder) return;
      if (!hasVideoPermission()) {
        const playerHadFocus = this.player && document.activeElement === this.player;
        this.player?.remove();
        this.player = null;
        this.placeholder.hidden = false;
        if (playerHadFocus) this.preferences.focus();
        return;
      }
      if (this.player) return;
      const id = this.dataset.videoId || '';
      if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
      const player = document.createElement('iframe');
      player.src = `https://www.youtube-nocookie.com/embed/${id}?playsinline=1&rel=0`;
      player.title = this.dataset.videoTitle || 'YouTube video';
      player.loading = 'lazy';
      player.allow = 'encrypted-media; fullscreen; picture-in-picture';
      player.allowFullscreen = true;
      player.referrerPolicy = 'strict-origin-when-cross-origin';
      this.player = player;
      this.placeholder.hidden = true;
      this.append(player);
    }

    async openPreferences() {
      try {
        const bridge = window.sigmaSwsVideoConsent;
        if (bridge) {
          if (typeof bridge.openPreferences !== 'function') throw new Error('CMP preferences unavailable');
          await bridge.openPreferences();
        } else if (typeof window.privacyBanner?.showPreferences === 'function') {
          await window.privacyBanner.showPreferences();
        } else {
          throw new Error('Cookie preferences unavailable');
        }
        this.updatePlayer();
      } catch (_) {
        if (this.message) this.message.textContent = this.dataset.consentFallback || '';
      }
    }

    disconnectedCallback() {
      window.cancelAnimationFrame(this.initFrame);
      this.listenerController?.abort();
      this.listenerController = null;
      this.player?.remove();
      this.player = null;
      if (this.placeholder) this.placeholder.hidden = false;
      if (this.preferences) this.preferences.hidden = true;
    }
  }

  customElements.define('article-sws-youtube', ArticleSwsYouTube);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-shooting-with-sigma"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const filterButtons = document.querySelectorAll('.filter-link');
    const articleItems = document.querySelectorAll('.blog-shooting-with-sigma-item');
    const gridContainer = document.querySelector('.blog-shooting-with-sigma-grid');

    // Debug: mostra le categorie disponibili
    console.log('Available categories:');
    articleItems.forEach(item => {
      const category = item.getAttribute('data-category');
      const title = item.querySelector('.blog-shooting-with-sigma-article-title').textContent;
      console.log(`- "${title}": "${category}"`);
    });

    filterButtons.forEach(button => {
      button.addEventListener('click', function() {
        const selectedCategory = this.getAttribute('data-category');
        console.log('Selected category:', selectedCategory);
        
        // Rimuovi classe active da tutti i bottoni
        filterButtons.forEach(btn => btn.classList.remove('active'));
        
        // Aggiungi classe active al bottone cliccato
        this.classList.add('active');
        
        // Riorganizza gli articoli
        const visibleItems = [];
        const hiddenItems = [];
        
        articleItems.forEach(item => {
          const itemCategory = item.getAttribute('data-category');
          console.log(`Checking item "${item.querySelector('.blog-shooting-with-sigma-article-title').textContent}" with category "${itemCategory}"`);
          
          if (selectedCategory === 'all' || itemCategory === selectedCategory) {
            item.classList.remove('hidden');
            visibleItems.push(item);
            console.log('Showing item');
          } else {
            item.classList.add('hidden');
            hiddenItems.push(item);
            console.log('Hiding item');
          }
        });
        
        // Riordina gli elementi nel DOM
        // Prima rimuovi tutti gli elementi
        articleItems.forEach(item => {
          item.remove();
        });
        
        // Poi riaggiungi prima quelli visibili, poi quelli nascosti
        visibleItems.forEach(item => {
          gridContainer.appendChild(item);
        });
        
        hiddenItems.forEach(item => {
          gridContainer.appendChild(item);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // Cart Drawer functionality
  class CartDrawer {
    constructor() {
      this.drawer = document.getElementById('cart-drawer');
      this.overlay = document.getElementById('cart-drawer-overlay');
      this.closeBtn = document.getElementById('cart-drawer-close');
      this.isOpen = false;
      
      this.init();
    }

    init() {
      // Close drawer events
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }
      
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      // Escape key to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
        }
      });

      // Quantity controls
      this.initQuantityControls();
    }

    open() {
      if (this.drawer) {
        this.drawer.classList.add('cart-drawer--open');
        document.body.classList.add('cart-drawer-open');
        this.isOpen = true;
      }
    }

    close() {
      if (this.drawer) {
        this.drawer.classList.remove('cart-drawer--open');
        document.body.classList.remove('cart-drawer-open');
        this.isOpen = false;
      }
    }

    initQuantityControls() {
      const quantityBtns = document.querySelectorAll('.cart-drawer__quantity-btn');
      const quantityInputs = document.querySelectorAll('.cart-drawer__quantity-input');
      const removeBtns = document.querySelectorAll('.cart-drawer__remove-btn');

      // Handle quantity button clicks
      quantityBtns.forEach(btn => {
        btn.addEventListener('click', function() {
          const lineItem = this.dataset.lineItem;
          const action = this.dataset.action;
          const input = document.querySelector(`input[data-line-item="${lineItem}"]`);
          
          if (input) {
            let currentValue = parseInt(input.value) || 0;
            
            if (action === 'increase') {
              input.value = currentValue + 1;
            } else if (action === 'decrease' && currentValue > 0) {
              input.value = currentValue - 1;
            }
            
            // Trigger form update
            input.dispatchEvent(new Event('change'));
          }
        });
      });

      // Handle quantity input changes
      quantityInputs.forEach(input => {
        input.addEventListener('change', function() {
          const form = document.getElementById('cart-drawer-form');
          if (form) {
            // Auto-submit form when quantity changes
            setTimeout(() => {
              form.submit();
            }, 500);
          }
        });
      });

      // Handle remove button clicks
      removeBtns.forEach(btn => {
        btn.addEventListener('click', function(e) {
          if (!confirm('Are you sure you want to remove this item from your cart?')) {
            e.preventDefault();
          }
        });
      });
    }
  }

  // Global functions to open/close drawer
  window.openCartDrawer = function() {
    if (window.cartDrawer) {
      window.cartDrawer.open();
    }
  };

  window.closeCartDrawer = function() {
    if (window.cartDrawer) {
      window.cartDrawer.close();
    }
  };

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    window.cartDrawer = new CartDrawer();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const dataPoolNodes = document.querySelectorAll('.compare-data');
  const productMap = {};

  // mappa handle -> HTML del prodotto
  dataPoolNodes.forEach(function(node) {
    const handle = node.dataset.handle;
    if (handle && !productMap[handle]) {
      productMap[handle] = node.innerHTML;
    }
  });

  function equalizeGroup(selector) {
    const elements = [];
    document.querySelectorAll('.compare-column').forEach(function(col) {
      const el = col.querySelector(selector);
      if (el) elements.push(el);
    });

    if (!elements.length) return;

    // reset
    elements.forEach(function(el) {
      el.style.minHeight = '';
    });

    // altezza massima
    let maxH = 0;
    elements.forEach(function(el) {
      const h = el.offsetHeight;
      if (h > maxH) maxH = h;
    });

    elements.forEach(function(el) {
      el.style.minHeight = maxH + 'px';
    });
  }

  function equalizeCompareRows() {
    const columns = document.querySelectorAll('.compare-column');
    if (!columns.length) return;

    // header e immagine
    equalizeGroup('.compare-product-header');
    equalizeGroup('.compare-product-image');

    // reset altezze delle righe
    const allItems = document.querySelectorAll('.compare-spec-item');
    allItems.forEach(function(item) {
      item.style.minHeight = '';
    });

    const lists = [];
    columns.forEach(function(col) {
      const list = col.querySelector('.compare-spec-list');
      if (list) lists.push(list);
    });

    if (!lists.length) return;

    const maxItems = Math.max.apply(null, lists.map(function(list) {
      return list.children.length;
    }));

    for (let i = 0; i < maxItems; i++) {
      let maxHeight = 0;
      const rowItems = [];

      lists.forEach(function(list) {
        const item = list.children[i];
        if (item) {
          rowItems.push(item);
          const h = item.offsetHeight;
          if (h > maxHeight) maxHeight = h;
        }
      });

      rowItems.forEach(function(item) {
        item.style.minHeight = maxHeight + 'px';
      });
    }
  }

  function updateColumnForSelect(select) {
    const slot = select.dataset.slot;
    const handle = select.value;
    const column = document.querySelector('.compare-column[data-slot="' + slot + '"]');
    if (!column) return;

    if (!handle || !productMap[handle]) {
      column.innerHTML = '';
      equalizeCompareRows();
      return;
    }

    column.innerHTML = productMap[handle];

    // aspetta il render e poi allinea le righe
    requestAnimationFrame(equalizeCompareRows);
  }

  const selects = document.querySelectorAll('.compare-select-input');

  // quando l utente cambia il select
  selects.forEach(function(select) {
    select.addEventListener('change', function() {
      updateColumnForSelect(select);
    });
  });

  // ricostruisce le colonne in base ai valori dei select
  function initFromSelects() {
    selects.forEach(function(select) {
      if (select.value && productMap[select.value]) {
        updateColumnForSelect(select);
      } else {
        const column = document.querySelector('.compare-column[data-slot="' + select.dataset.slot + '"]');
        if (column && !select.value) {
          column.innerHTML = '';
        }
      }
    });
  }

  // prima apertura normale
  initFromSelects();

  // back del browser con pagina presa dalla cache
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      initFromSelects();
    }
  });

  // se cambia la larghezza ricalcolo
  window.addEventListener('resize', function() {
    requestAnimationFrame(equalizeCompareRows);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"]) return;
  try {
    
  // Login Drawer functionality
  class LoginDrawer {
    constructor() {
      this.drawer = document.getElementById('login-drawer');
      this.overlay = document.getElementById('login-drawer-overlay');
      this.closeBtn = document.getElementById('login-drawer-close');
      this.isOpen = false;
      
      this.init();
    }

    init() {
      // Close drawer events
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }
      
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      // Escape key to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
        }
      });

      // Form switching functionality
      this.initFormSwitching();
    }

    open() {
      if (this.drawer) {
        this.drawer.classList.add('login-drawer--open');
        document.body.classList.add('login-drawer-open');
        this.isOpen = true;
        
        // Focus first input
        setTimeout(() => {
          const firstInput = this.drawer.querySelector('input[type="email"]');
          if (firstInput) {
            firstInput.focus();
          }
        }, 300);
      }
    }

    close() {
      if (this.drawer) {
        this.drawer.classList.remove('login-drawer--open');
        document.body.classList.remove('login-drawer-open');
        this.isOpen = false;
      }
    }

    initFormSwitching() {
      const forgotLink = document.querySelector('.login-drawer__link--forgot');
      const backLink = document.querySelector('.login-drawer__link--back');
      const loginContainer = document.querySelector('.login-drawer__form-container');
      const recoverContainer = document.querySelector('.login-drawer__recover-container');

      if (forgotLink && recoverContainer && loginContainer) {
        forgotLink.addEventListener('click', (e) => {
          e.preventDefault();
          loginContainer.style.display = 'none';
          recoverContainer.style.display = 'block';
        });
      }

      if (backLink && recoverContainer && loginContainer) {
        backLink.addEventListener('click', (e) => {
          e.preventDefault();
          recoverContainer.style.display = 'none';
          loginContainer.style.display = 'block';
        });
      }
    }
  }

  // Global functions to open/close drawer
  window.openLoginDrawer = function() {
    if (window.loginDrawer) {
      window.loginDrawer.open();
    }
  };

  window.closeLoginDrawer = function() {
    if (window.loginDrawer) {
      window.loginDrawer.close();
    }
  };

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    window.loginDrawer = new LoginDrawer();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-register"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('form[action*="customers"]');
    const passwordInput = document.getElementById('customer_password');
    const emailInput = document.getElementById('customer_email');

    // Password strength indicator
    if (passwordInput) {
      passwordInput.addEventListener('input', function() {
        const password = this.value;
        const strength = getPasswordStrength(password);
        updatePasswordStrength(strength);
      });
    }

    // Email validation
    if (emailInput) {
      emailInput.addEventListener('blur', function() {
        const email = this.value;
        if (email && !isValidEmail(email)) {
          showFieldError(this, 'Please enter a valid email address');
        } else {
          clearFieldError(this);
        }
      });
    }

    // Form submission validation
    if (form) {
      form.addEventListener('submit', function(e) {
        const firstName = document.getElementById('customer_first_name').value.trim();
        const lastName = document.getElementById('customer_last_name').value.trim();
        const email = document.getElementById('customer_email').value.trim();
        const password = document.getElementById('customer_password').value;

        let hasErrors = false;

        if (!firstName) {
          showFieldError(document.getElementById('customer_first_name'), 'First name is required');
          hasErrors = true;
        }

        if (!lastName) {
          showFieldError(document.getElementById('customer_last_name'), 'Last name is required');
          hasErrors = true;
        }

        if (!email || !isValidEmail(email)) {
          showFieldError(document.getElementById('customer_email'), 'Valid email is required');
          hasErrors = true;
        }

        if (!password || password.length < 5) {
          showFieldError(document.getElementById('customer_password'), 'Password must be at least 5 characters');
          hasErrors = true;
        }

        if (hasErrors) {
          e.preventDefault();
        }
      });
    }

    function getPasswordStrength(password) {
      let strength = 0;
      if (password.length >= 5) strength++;
      if (password.length >= 8) strength++;
      if (/[A-Z]/.test(password)) strength++;
      if (/[0-9]/.test(password)) strength++;
      if (/[^A-Za-z0-9]/.test(password)) strength++;
      return strength;
    }

    function updatePasswordStrength(strength) {
      // Remove existing strength indicator
      const existingIndicator = document.querySelector('.password-strength');
      if (existingIndicator) {
        existingIndicator.remove();
      }

      if (strength > 0) {
        const indicator = document.createElement('div');
        indicator.className = 'password-strength';
        indicator.innerHTML = `
          <div class="password-strength__bar">
            <div class="password-strength__fill" style="width: ${(strength / 5) * 100}%"></div>
          </div>
          <span class="password-strength__text">${getStrengthText(strength)}</span>
        `;
        
        passwordInput.parentNode.appendChild(indicator);
      }
    }

    function getStrengthText(strength) {
      const texts = ['Very Weak', 'Weak', 'Fair', 'Good', 'Strong'];
      return texts[Math.min(strength - 1, 4)] || '';
    }

    function isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    function showFieldError(field, message) {
      clearFieldError(field);
      field.style.borderColor = '#d32f2f';
      
      const errorDiv = document.createElement('div');
      errorDiv.className = 'field-error';
      errorDiv.textContent = message;
      errorDiv.style.color = '#d32f2f';
      errorDiv.style.fontSize = '12rem';
      errorDiv.style.marginTop = '4rem';
      errorDiv.style.fontFamily = '"Sigma Serif"';
      
      field.parentNode.appendChild(errorDiv);
    }

    function clearFieldError(field) {
      field.style.borderColor = '#e0e0e0';
      const existingError = field.parentNode.querySelector('.field-error');
      if (existingError) {
        existingError.remove();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-full-img"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-hero-full-img]').forEach((hero) => {
      const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
      const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
      const nextButton = hero.querySelector('[data-hero-next]');
      const previousButton = hero.querySelector('[data-hero-prev]');
      const autoplay = hero.dataset.autoplay === 'true';
      const interval = Number(hero.dataset.interval) || 6000;
      let currentIndex = 0;
      let timer;

      if (slides.length < 2) return;

      const showSlide = (index) => {
        currentIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === currentIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      const restartAutoplay = () => {
        window.clearInterval(timer);
        if (autoplay) timer = window.setInterval(() => showSlide(currentIndex + 1), interval);
      };

      nextButton?.addEventListener('click', () => {
        showSlide(currentIndex + 1);
        restartAutoplay();
      });
      previousButton?.addEventListener('click', () => {
        showSlide(currentIndex - 1);
        restartAutoplay();
      });
      dots.forEach((dot) => dot.addEventListener('click', () => {
        showSlide(Number(dot.dataset.heroDot));
        restartAutoplay();
      }));

      showSlide(0);
      restartAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const quantityInputs = document.querySelectorAll('.main-cart__quantity-input');
    const quantityBtns = document.querySelectorAll('.main-cart__quantity-btn');
    const removeBtns = document.querySelectorAll('.main-cart__remove-btn');

    // Handle quantity button clicks
    quantityBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const lineItem = this.dataset.lineItem;
        const action = this.dataset.action;
        const input = document.querySelector(`input[data-line-item="${lineItem}"]`);
        
        if (input) {
          let currentValue = parseInt(input.value) || 0;
          
          if (action === 'increase') {
            input.value = currentValue + 1;
          } else if (action === 'decrease' && currentValue > 0) {
            input.value = currentValue - 1;
          }
          
          // Trigger form update
          input.dispatchEvent(new Event('change'));
        }
      });
    });

    // Handle quantity input changes
    quantityInputs.forEach(input => {
      input.addEventListener('change', function() {
        const form = document.getElementById('cart');
        if (form) {
          // Auto-submit form when quantity changes
          setTimeout(() => {
            form.submit();
          }, 500);
        }
      });
    });

    // Handle remove button clicks
    removeBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        if (!confirm('Are you sure you want to remove this item from your cart?')) {
          e.preventDefault();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabNavItems = document.querySelectorAll('.page-tabs__nav-item');
    const tabContentPanels = document.querySelectorAll('.page-tabs__content-panel');
    const accordionTriggers = document.querySelectorAll('.accordion__trigger');
    
    // Gestione tab navigation
    tabNavItems.forEach(item => {
      item.addEventListener('click', function() {
        const targetTab = this.getAttribute('data-tab');
        
        // Rimuovi classe active da tutti i nav items
        tabNavItems.forEach(navItem => navItem.classList.remove('active'));
        
        // Aggiungi classe active al nav item cliccato
        this.classList.add('active');
        
        // Nascondi tutti i content panels
        tabContentPanels.forEach(panel => panel.classList.remove('active'));
        
        // Mostra il content panel corrispondente
        const targetPanel = document.querySelector(`[data-tab="${targetTab}"].page-tabs__content-panel`);
        if (targetPanel) {
          targetPanel.classList.add('active');
        }
      });
    });
    
    // Gestione accordion
    accordionTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const content = this.nextElementSibling;
        
        // Chiudi tutti gli altri accordion
        accordionTriggers.forEach(otherTrigger => {
          if (otherTrigger !== this) {
            otherTrigger.setAttribute('aria-expanded', 'false');
            otherTrigger.nextElementSibling.style.maxHeight = '0';
          }
        });
        
        // Toggle dell'accordion corrente
        this.setAttribute('aria-expanded', !isExpanded);
        
        if (!isExpanded) {
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          content.style.maxHeight = '0';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
   function initAccordions() {
     const accordionTriggers = document.querySelectorAll('.accordion__trigger');
     
     // Imposta target="_blank" per tutti i link negli accordion
     const accordionLinks = document.querySelectorAll('.accordion__content a');
     accordionLinks.forEach(link => {
       link.setAttribute('target', '_blank');
     });
     
     accordionTriggers.forEach(trigger => {
       trigger.addEventListener('click', function(e) {
         e.preventDefault();
         e.stopPropagation();
         
         const isExpanded = this.getAttribute('aria-expanded') === 'true';
         const content = this.nextElementSibling;
         
         if (!content) return;
         
          // Chiudi tutti gli altri accordion
          accordionTriggers.forEach(otherTrigger => {
            if (otherTrigger !== this) {
              otherTrigger.setAttribute('aria-expanded', 'false');
              const otherContent = otherTrigger.nextElementSibling;
              if (otherContent) {
                otherContent.style.maxHeight = '0';
                otherContent.style.display = 'none';
              }
            }
          });
         
          // Toggle dell'accordion corrente
          if (isExpanded) {
            this.setAttribute('aria-expanded', 'false');
            content.style.maxHeight = '0';
            content.style.display = 'none';
          } else {
            this.setAttribute('aria-expanded', 'true');
            content.style.display = 'block';
            content.style.maxHeight = 'fit-content';
          }
       });
     });
   }
   
   // Inizializza quando il DOM è pronto
   if (document.readyState === 'loading') {
     document.addEventListener('DOMContentLoaded', initAccordions);
   } else {
     initAccordions();
   }


 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resellers"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {

  const items = Array.from(document.querySelectorAll('.reseller-item'));
  const searchInput = document.getElementById('reseller-search');
  const regionFilter = document.getElementById('region-filter');
  const paginationContainer = document.getElementById('resellers-pagination');
  const filtersStart = document.querySelector('#resellers-filters-start');

  const itemsPerPage = 20;

  let currentPage = 1;
  let filteredItems = items.slice();


  function renderPage(page, scroll) {

    currentPage = page;

    items.forEach(function(item) {
      item.style.display = 'none';
    });

    const totalItems = filteredItems.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;

    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    filteredItems
      .slice(startIndex, endIndex)
      .forEach(function(item) {
        item.style.display = 'block';
      });


    paginationContainer.innerHTML = '';

    if (totalPages <= 1) {
      return;
    }


    const prev = document.createElement('a');

    prev.textContent = '←';
    prev.classList.add('pagination-arrow');

    if (page > 1) {

      prev.addEventListener('click', function() {
        renderPage(page - 1, true);
      });

    } else {

      prev.classList.add('disabled');

    }

    paginationContainer.appendChild(prev);


    for (let i = 1; i <= totalPages; i++) {

      const btn = document.createElement('a');

      btn.textContent = i;
      btn.classList.add('pagination-number');

      if (i === page) {
        btn.classList.add('active');
      }

      btn.addEventListener('click', function() {
        renderPage(i, true);
      });

      paginationContainer.appendChild(btn);

    }


    const next = document.createElement('a');

    next.textContent = '→';
    next.classList.add('pagination-arrow');

    if (page < totalPages) {

      next.addEventListener('click', function() {
        renderPage(page + 1, true);
      });

    } else {

      next.classList.add('disabled');

    }

    paginationContainer.appendChild(next);


    if (scroll && filtersStart) {

      filtersStart.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    }

  }


  function applyFilters() {

    const term = searchInput
      ? searchInput.value.toLowerCase().trim()
      : '';

    const region = regionFilter
      ? regionFilter.value.toLowerCase().trim()
      : '';


    filteredItems = items.filter(function(item) {

      const name = (item.dataset.name || '')
        .toLowerCase()
        .trim();

      const reg = (item.dataset.region || '')
        .toLowerCase()
        .trim();


      const matchName =
        !term || name.includes(term);

      const matchRegion =
        !region || reg === region;


      return matchName && matchRegion;

    });


    renderPage(1, false);

  }


  if (searchInput) {

    searchInput.addEventListener(
      'input',
      applyFilters
    );

  }


  if (regionFilter) {

    regionFilter.addEventListener(
      'change',
      applyFilters
    );

  }


  applyFilters();

});


  } catch(e) { console.error(e); }
})();
})();
